import styled from 'styled-components'

import type { PropsWithChildren } from 'react'

type ActionsListProps = PropsWithChildren
export const ActionsList = ({ children }: ActionsListProps) => {
  return <Root>{children}</Root>
}

const Root = styled.div`
  display: grid;
  gap: 10px;
`
